import React, { useState, useCallback } from 'react';

export interface useInputProps {
  type: string;
  placeholder?: string;
  value?: string;
  classNames?: string;
}

export function useInput({ type, placeholder, value, classNames }: useInputProps): [string, JSX.Element] {
  const [inputValue, setInputValue] = useState(value || '');
  const onChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(e => setInputValue(e.target.value), []);

  const inputElement = (
    <input className={classNames} value={inputValue} onChange={onChange} type={type} placeholder={placeholder} />
  );

  return [inputValue, inputElement];
}
